exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown-caret-component.meatball-caret{cursor:pointer;display:inline-block}.dropdown-caret-component.meatball-caret.vp-icon.vertical-dots{width:4px;min-width:0}.dropdown-caret-component.meatball-caret.vp-icon.vertical-dots .dot{margin-left:0;marign-right:0}.dropdown-caret-component.meatball-caret.white-meatball.vp-icon.vertical-dots .dot{border-color:#fff}.dropdown-caret-component.meatball-caret.open.vp-icon.vertical-dots .dot,.dropdown-caret-component.meatball-caret.white-meatball.open.vp-icon.vertical-dots .dot{border-color:#6be}", ""]);

// exports
